/**
 * @module:  okr相关辅助函数
 * @author: Liang Huang 
 * @date: 2020-05-15 14:53:17 
 */

import { IDepartments } from "@src/entity/okr/okr";
import { Toast } from "antd-mobile";
import _ from 'lodash';

export const unique = (data: any[], key: string) => {
  return data.filter((item, index, arr) => {
    return arr.findIndex(val => val[key] === item[key]) === index;
  })
}

/**
 * 递归获取type=person人员
 */
export const findDeepPerson = (data: IDepartments[], limit = true) => {
  let arr: IDepartments[] = [];

  const func = (innerData) => {
    innerData.forEach(v => {
      if (v.type === 'person') {
        arr.push(v)
      } else if (v.type === 'department' && v.children) {
        func(v.children);
      }
    })
  }
  func(data);
  // 去重
  arr = _.uniqBy(arr, 'key');

  if(arr.length > 99 && limit) {
    Toast.info('最多选择99人', 1);
    return [];
  }


  // 去重
  return arr;
}

/**
 * 递归获取type=department人员
 */
export const findDeepDepart = (data: IDepartments[]) => {
  let arr: IDepartments[] = [];

  const func = (innerData) => {
    innerData.forEach(v => {
      if (v.type === 'department') {
        arr.push(v)
      } else if (v.children) {
        func(v.children);
      }
    })
  }
  func(data);
  arr = arr.filter((item, index, arr) => {
    return arr.findIndex(val => val.key === item.key) === index;
  })
  return arr;
}

export const decodeAtMsg = (text, isNofity) => {
  if (!text) return ''
  let msg = text
  // 解析 @ta
  msg = msg.replace(/&lt;/g, '<')
  msg = msg.replace(/&gt;/g, '>')
  if (isNofity) {
    msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '@$2')
  } else {
    msg = msg.replace(/\n/g, '{{br}}')
    msg = msg.replace(/\s/g, '&ensp;')
    msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '{{span data-uuid="$1" class="atta"}}@$2{{/span}} ')
  }
  msg = msg.replace(/{{/g, '<')
  msg = msg.replace(/}}/g, '>')
  return msg
}

// 统一date格式 2020.05.20 在iOS上会被转化为invaid date
export const styledDate = (str: string) => {
  if(typeof str !== 'string') return '';
  let strArr = str.split('.');
  if(strArr.length !== 3) return str;
  return strArr.join('-');
}